<template>
  <div>
    <deal-form
      v-if="modalVisible"
      :deal-id="dealId"
      :is-read-only="isReadOnly"
      :modal-visible="modalVisible"
      @close="closeModal"
      @close-and-refresh="closeAndRefresh"
      @save-event="saveEvent"
      @create-new="closeAndOpenModalCreate"
    />
    <div v-show="!modalVisible">
      <page-toolbar>
        <kendo-dropdownlist
          :data-source="evaluationYearsDataSource"
          :data-text-field="'year'"
          :data-value-field="'year'"
          v-model="year"
          @databound="onYearDataBound"
          @change="onYearChange"
          style="width: 75px;"
        ></kendo-dropdownlist>
        <kendo-dropdownlist
          :data-source="evaluationDatesDataSource"
          :data-text-field="'evaluationDateText'"
          :data-value-field="'evaluationDate'"
          v-model="evaluationDate"
          @databound="onEvaluationDatesDataBound"
          @change="onEvaluationDatesChange"
          :autoBind="false"
          style="width: 120px;"
        ></kendo-dropdownlist>
        <kendo-dropdownlist
          :data-source="evaluationTypesDataSource"
          :data-text-field="'description'"
          :data-value-field="'evaluationTypeId'"
          :autoBind="false"
          v-model="evaluationTypeId"
          @databound="onEvaluationTypeDataBound"
          @change="onEvaluationTypeChange"
          style="width: 75px;"
        ></kendo-dropdownlist>
        <kendo-button
          icon="trash"
          title="Delete evaluation"
          :enable="!isDeleting"
          @click="deleteEvaluation"
        ></kendo-button>
        <kendo-button icon="refresh" title="clear filters" @click="clearFilters"></kendo-button>
      </page-toolbar>
      <kendo-grid
        height="calc(100vh - 145px)"
        :dataSource="gridDataSource"
        ref="grid"
        :filterable="true"
        :sortable="true"
        :autoBind="false"
        :pageable-always-visible="true"
        :columns="columns"
      ></kendo-grid>
    </div>
  </div>
</template>

<script>
import PageToolbar from '@/components/PageToolbar'
import {enableExportExcel} from '@/helpers/export-helper'
import DealForm from '@/views/List/Deal/DealForm'
import {getDataItem} from '@/helpers/kendo-helpers'
import {mapGetters} from 'vuex'
import security from '@/mixins/security'
import axios from 'axios'
const $ = kendo.jQuery
export default {
  mixins: [security],
  mounted() {
    let grid = this.$refs.grid.kendoWidget()
    grid.element.on('click', '.dealCodeLink', e => {
      const dataItem = getDataItem(e.target)
      this.modalVisible = true
      this.dealId = dataItem.dealId
    })
    enableExportExcel(
      grid,
      '/api/heroux/TradeEvaluation/exportGridToExcel',
      $('.page_toolbar-item'),
    )
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    columns() {
      return [
        {
          field: 'dealId',
          title: 'Group Id',
          width: 100,
          attributes: {style: 'text-align: left;'},
          locked: true,
        },
        {
          field: 'number',
          title: 'Trade Id',
          width: 100,
          attributes: {style: 'text-align: left;'},
          template: kendo.template('<a href="javascript:;" class="dealCodeLink">#=number#</a>'),
        },
        {field: 'sector', width: 100, title: 'Sector'},
        {
          field: 'evaluationDate',
          format: '{0:yyyy-MM-dd}',
          title: 'Evaluation Date',
          width: 150,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
        },
        {field: 'mtmType', width: 100, title: 'MtmType'},
        {field: 'division', width: 100, title: 'Division'},
        {field: 'counterparty', width: 150, title: 'Counterparty'},
        {
          field: 'reference',
          title: 'Reference',
          width: 200,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'description',
          title: 'Description',
          headerAttributes: {style: 'text-align: center;'},
          width: 350,
          attributes: {style: 'text-align: left;'},
        },
        {width: 100, field: 'product', title: 'Product'},
        {width: 100, field: 'tradeDate', title: 'Trade Date', format: '{0:yyyy-MM-dd}'},
        {width: 100, field: 'startDate', title: 'Start Date', format: '{0:yyyy-MM-dd}'},
        {width: 100, field: 'maturityDate', title: 'Maturity Date', format: '{0:yyyy-MM-dd}'},
        {width: 120, field: 'settlementDate', title: 'Settlement Date', format: '{0:yyyy-MM-dd}'},
        {width: 100, field: 'buySell', title: 'BuySell'},
        {
          field: 'amountCcy1',
          title: 'AmountCcy1',
          width: 140,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n0}',
        },
        {width: 75, field: 'ccy1', title: 'Ccy1'},
        {
          width: 120,
          field: 'hedgeRate',
          title: 'HedgeRate',
          attributes: {style: 'text-align: right;'},
        },
        {width: 100, field: 'sellBuy', title: 'SellBuy'},
        {
          field: 'amountCcy2',
          title: 'AmountCcy2',
          width: 140,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n0}',
        },
        {width: 75, field: 'ccy2', title: 'Ccy2'},
        {
          field: 'evaluation',
          title: 'Eval.',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n2}',
        },
        {
          field: 'dfFwd',
          title: 'DF',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n5}',
        },
        {
          field: 'fwdRate',
          title: 'Fwd Rate',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n5}',
        },
        {
          field: 'riskDf',
          title: 'Risk Df',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n5}',
        },
        {
          field: 'riskEval',
          title: 'Risk Eval',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n2}',
        },
        {width: 75, field: 'mtmCcy', title: 'Mtm Ccy'},
        {
          field: 'riskEvalCad',
          title: 'Risk Eval CAD',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n2}',
        },
        {
          field: 'referenceRate',
          title: 'ReferenceRate',
          width: 150,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n5}',
        },
        {width: 100, field: 'forwardPoints', title: 'FWD Points'},
        {
          field: 'otherBarrier',
          title: 'Other Barrier',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n5}',
        },
        {
          field: 'increase',
          title: 'Increase (10%)',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n2}',
        },
        {
          field: 'increaseRisk',
          title: 'Inc. Risk',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n2}',
        },
        {
          field: 'decrease',
          title: 'Decrease (10%)',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n2}',
        },
        {
          field: 'decreaseRisk',
          title: 'Dec. Risk',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n2}',
        },
        {width: 150, field: 'hedgeType', title: 'HedgeType'},
        {width: 150, field: 'exercised', title: 'Exercised'},
        {width: 100, field: 'status', title: 'Status'},
        {width: 170, field: 'lastModified', title: 'LastModified', format: '{0:yyyy-MM-dd}'},
        {width: 100, field: 'lastUser', title: 'LastUser'},
      ]
    },
  },
  components: {
    DealForm,
    PageToolbar,
  },
  methods: {
    async deleteEvaluation() {
      const {clientId, evaluationTypeId, evaluationDate} = this
      const params = {clientId, evaluationTypeId, evaluationDate}

      if (!confirm('Are you sure to delete the selected evaluation?')) {
        return
      }

      this.isDeleting = true
      await axios.delete('/api/heroux/TradeEvaluation/deleteEvaluationDate', {params})
      this.evaluationYearsDataSource.read()
      this.isDeleting = false
    },
    closeAndRefresh() {
      this.gridDataSource.read()
      this.closeModal()
    },
    closeAndOpenModalCreate() {
      this.closeModal()

      setTimeout(() => {
        this.openModalCreate()
      }, 500)
    },
    closeModal() {
      this.dealId = null
      this.modalVisible = false
    },
    saveEvent(dealId) {
      this.dealId = dealId
      //let grid = this.$refs.dealGrid.kendoWidget()
      //grid.dataSource.read()
    },
    clearFilters() {
      this.gridDataSource.filter([])
    },
    onYearDataBound(e) {
      e.sender.select(0)
      this.year = e.sender.value()
      e.sender.trigger('change')
    },
    onYearChange(e) {
      this.year = e.sender.value()
      this.evaluationDatesDataSource.read()
    },
    onEvaluationDatesDataBound(e) {
      e.sender.select(0)
      this.evaluationDate = e.sender.value()
      e.sender.trigger('change')
    },
    onEvaluationDatesChange(e) {
      this.evaluationDate = e.sender.value()
      this.evaluationTypesDataSource.read()
    },
    onEvaluationTypeDataBound(e) {
      e.sender.select(0)
      this.evaluationTypeId = e.sender.value()
      e.sender.trigger('change')
    },
    onEvaluationTypeChange(e) {
      this.evaluationTypeId = e.sender.value()
      this.gridDataSource.read()
    },
  },
  data() {
    return {
      isDeleting: false,
      dealId: null,
      modalVisible: false,
      evaluationTypeId: -1,
      evaluationDate: null,
      year: -1,
      evaluationYearsDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/TradeEvaluation/getEvaluationYears',
            contentType: 'application/json',
            data: () => ({
              clientId: this.clientId,
            }),
            type: 'GET',
          },
        },
      }),
      evaluationDatesDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/TradeEvaluation/getEvaluationDates',
            contentType: 'application/json',
            data: () => ({
              clientId: this.clientId,
              year: this.year,
            }),
            type: 'GET',
          },
        },
      }),
      evaluationTypesDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/TradeEvaluation/getEvaluationTypes',
            contentType: 'application/json',
            data: () => ({
              clientId: this.clientId,
              evalDate: this.evaluationDate,
            }),
            type: 'GET',
          },
        },
      }),
      gridDataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/heroux/TradeEvaluation',
            data: () => ({
              clientId: this.clientId,
              evaluationTypeId: this.evaluationTypeId,
              evaluationDate: this.evaluationDate,
              showHypothetical: false,
            }),
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/heroux/TradeEvaluation',
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'dealId',
            fields: {
              dealId: {type: 'number'},
              number: {type: 'string'},
              sector: {type: 'string'},
              evaluationDate: {type: 'date'},
              mtmType: {type: 'string'},
              division: {type: 'string'},
              counterparty: {type: 'string'},
              reference: {type: 'string'},
              description: {type: 'string'},
              product: {type: 'string'},
              tradeDate: {type: 'date'},
              startDate: {type: 'date'},
              maturityDate: {type: 'date'},
              settlementDate: {type: 'date'},
              buySell: {type: 'string'},
              amountCcy1: {type: 'number'},
              ccy1: {type: 'string'},
              hedgeRate: {type: 'number'},
              sellBuy: {type: 'string'},
              amountCcy2: {type: 'number'},
              ccy2: {type: 'string'},
              evaluation: {type: 'number'},
              dfFwd: {type: 'number'},
              fwdRate: {type: 'number'},
              riskDf: {type: 'number'},
              riskEval: {type: 'number'},
              referenceRate: {type: 'number'},
              forwardPoints: {type: 'number'},
              otherBarrier: {type: 'number'},
              hedgeType: {type: 'string'},
              exercised: {type: 'bool'},
              status: {type: 'string'},
              lastModified: {type: 'date'},
              lastUser: {type: 'string'},
            },
          },
        },
      }),
    }
  },
}
</script>
